import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import green from '@material-ui/core/colors/green';
// import yellow from '@material-ui/core/colors/yellow';
// import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

// https://stackoverflow.com/questions/51625628/material-ui-radio-with-a-button-like-appearance

const styles = theme => ({
  formControl: {
    display: 'flex',
    flexBasis: 'auto',
    alignItems: 'center',
    margin:  theme.spacing(3 / 2)
  },
  formGroup: {
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'nowrap'
  },
  radioFlex: {
    flex: '1 1 auto',
    margin: '0 5px'
  },
  greyButtonRoot: {
    backgroundColor: '#00000004',
    borderRadius: 5,
    border: '1px solid',
    color: grey['700'],
    fontFamily: 'monospace',
    fontSize: '180%',
    height: 32,
    '&$checked': {
      backgroundColor: grey['700'],
      color: 'white'
    },
    '&$checked:hover': {
      backgroundColor: grey['500']
    },
    '&:not($checked):hover': {
      backgroundColor: grey['200']
    },
    transition: 'background-color 250ms'
  },
  // disabled: {
  //   backgroundColor: '#00000004'
  // },
  checked: {}
});

function QRadios(props) {
  const {
    classes,
    error,
    required,
    id,
    label,
    name,
    value,
    onChange,
    onBlur,
    types,
    disabled
  } = props;

  return (
    <FormControl className={classes.formControl} required={required}>
      <InputLabel
        error={error}
        required={required}
        shrink
        style={{
          position: 'relative',
          marginBottom: '10px'
        }}
      >
        {label}
      </InputLabel>
      <RadioGroup
        className={classes.formGroup}
        row
        id={id}
        name={name}

        value={value}
        onChange={onChange}
        onBlur={onBlur}
      >
        <Radio
          htmlFor={id}
          className={classes.radioFlex}
          disabled={disabled}
          value={types[0]}
          classes={{
            root: classes.greyButtonRoot,
            checked: classes.checked
          }}
          icon={types[0]}
          checkedIcon={types[0]}
        />
        <Radio
          htmlFor={id}
          className={classes.radioFlex}
          disabled={disabled}
          value={types[1]}
          classes={{
            root: classes.greyButtonRoot,
            checked: classes.checked,
            disabled: classes.disabled
          }}
          icon={types[1]}
          checkedIcon={types[1]}
          // disabled={binaryChoice}
        />
{    types.length === 3 &&     
        <Radio
          htmlFor={id}
          className={classes.radioFlex}
          disabled={disabled}
          value={types[2]}
          classes={{
            root: classes.greyButtonRoot,
            checked: classes.checked,
            disabled: classes.disabled
          }}
          icon={types[2]}
          checkedIcon={types[2]}
          // disabled={binaryChoice}
        />}
      </RadioGroup>
    </FormControl>
  );
}

QRadios.propTypes = {
  classes: PropTypes.object.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  binaryChoice: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func
};

QRadios.defaultProps = {
  required: false,
  binaryChoice: false,
  error: false,
  onBlur: null,
  value: ''
};

export default withStyles(styles)(QRadios);